import { logError } from "Logger";
import { addLoader, clearLoader } from "common/components/WithLoader/LoadingActions";
import { CreateTransferLoader } from "../../CreateTransferLoader.types";
import { prepClient } from "Clients";
import { toast } from "common/components/ui";
import { FormattedMessage } from "react-intl";
import { PREP_INSTRUCTIONS_PAGE_LABELS } from "prep/create/PrepInstructions/PrepInstructions.labels";
import React from "react";

export const resetPrepInstructions = async (dispatch, dpId): Promise<boolean> => {
  try {
    dispatch(addLoader(CreateTransferLoader.CreateTransferOrderLoader));
    await prepClient.updatePrepJobNote(dpId, { note: undefined });
    return true;
  } catch (err) {
    toast.error(<FormattedMessage {...PREP_INSTRUCTIONS_PAGE_LABELS.submitError} />);
    logError({ fn: "resetPrepInstructions" }, err);
    return false;
  } finally {
    dispatch(clearLoader(CreateTransferLoader.CreateTransferOrderLoader));
  }
};
